import { modalComponentModule } from '../../../../shared/app/components/modal/modal';
import attachDialogTemplate from './attach-dialog.tpl.html';
import detachDialogTemplate from './detach-dialog.tpl.html';
import './attach-dialog.less';
import { attachServiceModule } from '../../services/attach-service/attach-service';
import { appConfig } from '../../../../shared/app/constants/app-config';
import { appAlertComponentModule } from '../../../../shared/app/components/app-alert/app-alert';
import {
  IS_WINDOWS,
  TERMINAL_COMMAND_SEP,
  TERMINAL_CONTINUE,
} from '../../../../shared/app/constants/keycodes';
import { copyButtonComponentModule } from '../../../../shared/app/components/copy-button/copy-button';

export const attachComponentModule = angular
  .module('Q.components.attach-dialog', [
    modalComponentModule,
    attachServiceModule,
    appAlertComponentModule,
    copyButtonComponentModule,
  ])

  .factory('attachDialog', function attachDialog($modal) {
    return {
      open(attach, solution) {
        return $modal.openOnce('detachDialog', {
          template: attach ? attachDialogTemplate : detachDialogTemplate,
          controller: 'AttachDialogCtrl as $ctrl',
          size: attach && 'lg',
          resolve: {
            attach: () => attach,
            solution: () => solution,
          },
        }).result;
      },
    };
  })
  .controller(
    'AttachDialogCtrl',
    function AttachDialogCtrl(
      $scope,
      $modalInstance,
      attach,
      solution,
      attachService,
      $http,
      $q,
      $location,
      appAlert,
    ) {
      const TERMINAL_PROMPT_WINDOWS = '>';
      const TERMINAL_PROMPT_DEFAULT = '$';
      const HOST = $location.host();
      const BASE_URL_ENV = 'Q_ATTACH_API_BASE_URL';
      const BASE_URL = `${$location.protocol()}://${HOST}:${$location.port()}/api`;
      const TERMINAL_BASE_URL = IS_WINDOWS
        ? `SET "${BASE_URL_ENV}=${BASE_URL}\n`
        : `${BASE_URL_ENV}=${BASE_URL} ${TERMINAL_CONTINUE}`;
      const PACKAGE = '@qualified/attach';
      const NPM_COMMAND = `npm i -g ${PACKAGE}`;
      const COMMAND_BASE = `${HOST === 'www.qualified.io' ? '' : TERMINAL_BASE_URL}qualified-attach --token=TOKEN`;

      const ctrl = this;

      ctrl.cancel = () => $modalInstance.dismiss();
      ctrl.terminalPrompt = IS_WINDOWS
        ? TERMINAL_PROMPT_WINDOWS
        : TERMINAL_PROMPT_DEFAULT;
      ctrl.installers = [
        {
          label: 'NPM Install & Attach',
          baseCmd: NPM_COMMAND,
          desc: 'Installs the Attach runner with NPM and immediately starts it for this challenge.',
        },
        {
          label: 'Already Installed',
          desc: 'If you already have the Attach runner installed, this command starts it for this challenge.',
        },
      ];

      ctrl.attach = (detectedNotice) => {
        if (detectedNotice) {
          appAlert.success('Attach connected successfully!');
        }
        $modalInstance.close(true);
      };

      ctrl.detach = () => {
        $modalInstance.close(false);
      };

      if (attach) {
        ctrl.connect = () => {
          if (ctrl.loading) return;
          try {
            ctrl.connectError = false;
            ctrl.loading = 2;
            const channel = attachService.create(
              solution.challengeId,
              $scope,
            ).channel;
            const id = channel.name.split(':')[1];
            // Close the dialog when Attach enters presence.
            const onEnter = ({ clientId, data }) => {
              if (clientId === id && data && data.app === 'attach') {
                ctrl.attach(true);
                channel.presence.unsubscribe('enter', onEnter);
              }
            };
            channel.presence.subscribe('enter', onEnter);

            channel.presence
              .get({ clientId: id })
              .then((members) => {
                if (
                  members &&
                  members.find((m) => m.data && m.data.app === 'attach')
                ) {
                  ctrl.attach(true);
                }
              })
              .catch(appAlert.modelError)
              .catch(() => {
                ctrl.connectError = true;
              })
              .finally(() => {
                ctrl.loading--;
              });

            // Get token
            $http
              .post(`${appConfig.baseApiRoot}attach/token`, {
                assessmentResultId: solution.assessmentResultId,
                challengeId: solution.challengeId,
              })
              .then((resp) => {
                const data = resp.data || {};
                ctrl.token = (data.data || data).token;
                if (!ctrl.token) {
                  return $q.reject(
                    'Unable to retrieve token, please try again',
                  );
                }
                const cmd = COMMAND_BASE.replace('TOKEN', ctrl.token);
                ctrl.installers.forEach((ins) => {
                  ins.cmd = ins.baseCmd
                    ? `${ins.baseCmd}${TERMINAL_COMMAND_SEP}${cmd}`
                    : cmd;
                  ins.cmds = IS_WINDOWS
                    ? ins.cmd.split('\n').map((c) => c + '\n')
                    : [ins.cmd];
                });
              })
              .catch(appAlert.modelError)
              .catch(() => {
                ctrl.connectError = true;
              })
              .finally(() => {
                ctrl.loading--;
              });
          } catch (err) {
            appAlert.modelError(err);
          }
        };
        ctrl.connect();
      }
    },
  );
